import Cta from "../../fragments/cta/Cta.jsx";
import ComponentWrapper from "../../fragments/component-wrapper/ComponentWrapper";

import CustomImage from "../../fragments/custom-image/CustomImage";

export default function TextInlineImages({ block, index }) {
  // console.log(block);
  if (!block) return null;

  return (
    <ComponentWrapper className="TextInlineImages" mode="theme-neutral dark">
      <div className={"l-grid"}>
        <div className="l-grid__col l-grid__col--l-10-12 l-grid__col--l-push-1-12">
          <h2>
            {block.headingItems.map((part, index) => (
              <span key={index}>
                <span>{part.text}</span>
                {part.image && (
                  <>
                    {" "}
                    <div className="TextInlineImages-image">
                      <CustomImage
                        className={`media`}
                        image={part.image}
                        fill={false}
                        forceHeight={true}
                        targetWidth={116}
                        targetHeight={84}
                        sizes={"10vw"}
                      />
                    </div>
                    {block.headingItems.length > index + 1 && " "}
                  </>
                )}
              </span>
            ))}
          </h2>
        </div>

        <div className="TextInlineImages-description l-grid__col l-grid__col--l-8-12 l-grid__col--l-push-2-12">
          {block.description && (
            <p className="text--size-xl text--condensed">{block.description}</p>
          )}
          {block.cta && (
            <div className="TextInlineImages-cta theme-brand">
              <Cta cta={block.cta} theme="secondary" />
            </div>
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
